import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface LoadingState {
  isLoading: boolean;
  loadingMessage?: string;
}

const initialState: LoadingState = {
  isLoading: false,
  loadingMessage: undefined,
};

export const loadingSlice = createSlice({
  name: "loading",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      if (!action.payload) {
        state.loadingMessage = undefined;
      }
    },
    setLoadingWithMessage: (
      state,
      action: PayloadAction<{ isLoading: boolean; message?: string }>
    ) => {
      state.isLoading = action.payload.isLoading;
      state.loadingMessage = action.payload.message;
    },
  },
});

export const { setLoading, setLoadingWithMessage } = loadingSlice.actions;

export const selectLoading = (state: RootState) => state.loading.isLoading;
export const selectLoadingMessage = (state: RootState) =>
  state.loading.loadingMessage;

export default loadingSlice.reducer;
